export default __webpack_public_path__ + "static/media/7.a836d502.png";